import React, { Component } from 'react';
import { EventEmitter } from 'events';
import ReactModal from 'react-modal';
import { WalkInList } from './WalkInList';
import { t } from '../../../../modules/infra/i18n';
import './walkInListModal.scss';

export default class WalkInListModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      opened: false,
    };
  }

  componentDidMount() {
    EventEmitter.prototype.on('open-walk-in-list-modal', this.openModal);
    EventEmitter.prototype.on('modal-closed', this.closeModal);
  }

  componentWillUnmount() {
    EventEmitter.prototype.removeListener('open-walk-in-list-modal', this.openModal);
    EventEmitter.prototype.removeListener('modal-closed', this.closeModal);
  }

  openModal = () => {
    this.setState({
      opened: true,
    });
  };

  closeModal = () => {
    if (this.state.opened) {
      this.setState({
        opened: false,
      });
    }
  };

  render() {
    return (
      <ReactModal
        className={{
          base: 'walk-in-list-slide-out',
          afterOpen: 'walk-in-list-slide-out--open',
          beforeClose: 'walk-in-list-slide-out--closing',
        }}
        overlayClassName={{
          base: 'walk-in-list-overlay',
          afterOpen: 'walk-in-list-overlay--open',
          beforeClose: 'walk-in-list-overlay--closing',
        }}
        closeTimeoutMS={300}
        onRequestClose={this.closeModal}
        contentLabel={t('appointment:walk_in_list.modal_content_label')}
        shouldCloseOnOverlayClick
        isOpen={this.state.opened}
        ariaHideApp={false}
      >
        <WalkInList onClose={this.closeModal} />
      </ReactModal>
    );
  }
}
